// extracted by mini-css-extract-plugin
export default {"customIcon":"BackBtn_customIcon__JfudO"};